import '../../styles/pages/author.scss';
import generateTabs from '../components/generateTabs'
import '../components/copy-to-clipboard';

generateTabs('author', {display: 'grid', hasCaching: false});

const readMoreEl = document.querySelector('.author-sidebar__read-more');
const aboutContentEl = document.querySelector('.author-sidebar__description');
const aboutContentText = aboutContentEl.textContent;

if (aboutContentText.length > 181) {
    aboutContentEl.innerHTML = aboutContentText.slice(0, 181) + '...';
} else {
    readMoreEl.hidden = true;
}

// aboutContentEl.innerHTML = '';

readMoreEl.onclick = () => {
    aboutContentEl.innerHTML = aboutContentText;
    readMoreEl.hidden = true;
}